import { useState } from "react";
import PublisherList from "./components/navigation/publisherList";
import CurriculaList from "./components/navigation/curriculaList";
import StandardsContainer from "./components/standards/standardsContainer";
import SelectedResource from "./components/resources/selectedResource";


export default function App() {

    const curricula = [
        {
          id: 1,
          title: "Florida State",
          code: "FL"
        }
    ]

    const [ generatingResults, setGeneratingResults ] = useState(false)
    const [ results, setResults ] = useState([])
    const [ data, setData ] = useState(curricula[0])
    const [ standard, setStandard ] = useState(false)
    const [ resourceSelected, setResourceSelected ] = useState(null)

    return(
        <div className="map__container">
            {generatingResults && <div className="map__container--disabled"></div>}

            <div className="map__heading">
                <div className="ai-body-large bold ai-grey-100">Content Mapping</div>
                <div className="map__publishers">
                    <PublisherList />
                </div>
            </div>
            <div className="map__heading">
                <CurriculaList setData={setData} setStandard={setStandard} curricula={curricula} data={data}/>
            </div> 
            <StandardsContainer setPageResults={setResults} results={results} data={data} standard={standard} setStandard={setStandard} generatingResults={generatingResults} setGeneratingResults={setGeneratingResults} setResourceSelected={setResourceSelected}/>
            {resourceSelected &&
            <SelectedResource resourceSelected={resourceSelected} setResourceSelected={setResourceSelected} />
            }
        </div>
        
    )
}